import React from 'react';
import Helpers from './Helpers.js'

import './CandidateView.css';


class CandidateView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		   
		}
	}

	render() {
		let partycode = "Andere";
		if(this.props.parties.o.hasOwnProperty(this.props.candidate.party)) {
			partycode = this.props.parties.o[this.props.candidate.party].partycode
		}
		if(this.props.candidate.percent+this.props.candidate.votes+this.props.candidate.electors>0) {
			return(
				<div className={"candidateBox " + partycode}>
					<h6 className='partyName'>
						{this.props.candidate.name}
					</h6>
					{ this.props.candidate.note.length>0 &&
					<div className='candidate-note'>
						{this.props.candidate.note}
					</div>
					}
					<div className='candidateInfo'>
						{this.props.candidate.party}
						{this.props.candidate.home.length>0 &&
						<div className='candidate-home'>
							{this.props.candidate.home}
						</div>
						}						
						{this.props.candidate.dob.length>0 &&
						<div className='candidate-dob'>
							{this.props.candidate.dob}
						</div>
						}
						<div>
							Elektoren: <span className='candidateValue'>{Helpers.tsnds(this.props.candidate.electors)} </span>
						</div>
						<div>
							Stimmen: <span className='candidateValue'>{Helpers.tsnds(this.props.candidate.percent)}%</span><br/>
							<span className='candidateValue'>{Helpers.tsnds(this.props.candidate.votes)} </span>
							<div className='candidate-aux'>
								<br/>Aux Votes:&nbsp;
								<span className='candidateValue'>{Helpers.tsnds(this.props.candidate.aux.votes)} </span>
								<br/>Aux Elektoren:&nbsp;
								{Helpers.tsnds(this.props.candidate.aux.electors)}            
								<br/>Aux Prozent:&nbsp;
								{Helpers.tsnds(this.props.candidate.aux.percent)}                              
							</div>

						</div>
						<div className='fullbar'>
							<div className='bar bar-votes' style = {{width:this.props.candidate.percent+'%' }}></div>
						</div>
					</div>                 
				</div>                
			)			
		}
		else {
			return false;
		}


	}
}

export default CandidateView
